// extracted by mini-css-extract-plugin
module.exports = {"tabs":"_13125","list":"_7999"};